/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Managebilling1Inputs */

const zh_subscription_managebilling1 = /** @type {(inputs: Subscription_Managebilling1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理账单`)
};

const en_subscription_managebilling1 = /** @type {(inputs: Subscription_Managebilling1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Billing`)
};

const es_subscription_managebilling1 = /** @type {(inputs: Subscription_Managebilling1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar facturación`)
};

/**
* | output |
* | --- |
* | "Manage Billing" |
*
* @param {Subscription_Managebilling1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_managebilling1 = /** @type {((inputs?: Subscription_Managebilling1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Managebilling1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_managebilling1(inputs)
	if (locale === "en") return en_subscription_managebilling1(inputs)
	return es_subscription_managebilling1(inputs)
});
export { subscription_managebilling1 as "subscription_manageBilling" }